import {
    Modal,
    Spinner
} from 'react-bootstrap';

export default function BuscaTexto(props) {
    return (
        <Modal
            id='modalLoading'
            backdropClassName='modalLoading'
            show={props.show}
            fullscreen={false}
            keyboard={false}
            centered
        >
            <Modal.Body>
                <Spinner
                    animation="border"
                    role="status"
                    variant="warning"
                >
                    <span className="visually-hidden">Carregando...</span>
                </Spinner>
            </Modal.Body>
        </Modal>
    );
}
